/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IUserLabTestItem } from 'app/shared/model/user-lab-test-item.model';
import { ILabTestItem } from 'app/shared/model/lab-test-item.model';
import { IBloodDonation } from 'app/shared/model/blood-donation.model';
import { IBloodBank } from 'app/shared/model/blood-bank.model';
import { IBloodBankInventory } from 'app/shared/model/blood-bank-inventory.model';

export interface IBloodInventoryInvestigation {
  id?: string;
  result?: string | null;
  observation?: string | null;
  statusCode?: string | null;
  limits?: string | null;
  active?: boolean | null;
  cursor?: number | null;
  lastUpdated?: number | null;
  microSec?: number | null;
  timestampEntry?: number | null;
  test?: IUserLabTestItem | null;
  baseTest?: ILabTestItem | null;
  donation?: IBloodDonation | null;
  bank?: IBloodBank | null;
  bloodBankInventory?: IBloodBankInventory | null;
}

export const defaultValue: Readonly<IBloodInventoryInvestigation> = {
  active: false,
};
